import { useEffect } from 'react';

export function useClickOutside(
  refs: React.RefObject<HTMLElement>[],
  handler: () => void,
  enabled: boolean = true,
) {
  useEffect(() => {
    if (!enabled) {
      return;
    }
    function handleClick(event: MouseEvent) {
      if (refs.every((ref) => ref.current && !ref.current.contains(event.target as Node))) {
        handler();
      }
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [refs, handler, enabled]);
}
